import { Box, Button, Checkbox, Grid, Tooltip, Typography } from '@mui/material'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import 'react-modern-drawer/dist/index.css'
import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { DrawerContext } from '../Context/DrawerContext'
import { animated, useTransition } from '@react-spring/web';
import { useFormContext } from '../Context/Context'
import { useEditMode } from '../Context/EditModeContext'
import { useTitleContext } from '../Context/TitleContext'
import { useFavoriteItems } from '../Context/FavoriteItemsContext'
import MainMessage from './MainMessage'
import { useSectionUrls } from "../api/GetMainPageFormApi";
import { sortItems } from "../Constant/MainNavbarSortItems";
import MobileMainDrawer from "./MobileMainDrawer";
import MainNavbarButtonAction from "./MainNavbarButtonAction/MainNavbarButtonAction";
import Loading from "./Loading/Loading";
import { useList } from "../Context/ListContext";
import { useStatusForm } from "../Context/StatusFormContext";
import { useLoading } from "../Context/LoadingContext";
import PaginationForms from "./Pagination/PaginationForms";
import { usePageCount } from "../Context/PageCount";
import { useActiveFilter } from '../Context/ActiveFilter';
import { useListResponse } from '../Context/ListResponse';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { handleChangeStarCheckBox } from '../helpers/handleChangeStarCheckBox';
import { copyFormLink } from '../helpers/copyFormLink';
import { handleGetFormDetails } from '../helpers/handleGetFormDetails';
import { handleGetListResponseForm } from '../helpers/handleGetListResponseForm';
import { handleGetListForms } from '../helpers/handleGetListForms';
import { FORM_ACTION_BUTTONS } from '../Constant/FormActions';
import FormItemRow from './FormItem/FormItemRow';
import PasswordModal from './PasswordModal/PasswordModal';
import { usePasswordProtectionForm } from '../Context/PasswordProtectionForm';
import { useSubmissionLimitSetting } from '../Context/FormLimited/SubmissionLimitSettingContext';




const MainNavbar = () => {




    const { selectDrawerItem, setSelectDrawerItem } = useContext(DrawerContext);
    const { drawerData, setDrawerData } = useFormContext();
    const { setEditMode } = useEditMode();
    const { title, setTitle } = useTitleContext();
    const { favoriteItems, setFavoriteItems } = useFavoriteItems();
    const { list, setList } = useList();
    const { statusForms, setStatusForms, saveStatusForm } = useStatusForm();
    const sectionUrls = useSectionUrls();
    const { setLoading } = useLoading()
    const { pageCount, setPageCount } = usePageCount()
    const { activeFilter, setActiveFilter } = useActiveFilter();
    const { setListResponse } = useListResponse();
    const { passwordProtectionForm, setPasswordProtectionForm } = usePasswordProtectionForm()
    const { handleChangeLimitSetting } = useSubmissionLimitSetting()




    const moreMenuRef = useRef(null);


    const navigate = useNavigate()

    const [isOpen, setIsOpen] = useState(false)
    const [checked, setChecked] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [active, setActive] = useState(false);
    const [heading, setHeading] = useState('');
    const [error, setError] = useState(null);
    const [formFullDetails, setFormFullDetails] = useState(null)
    const [switchSection, setSwitchSection] = useState('all')
    const [filteredListData, setFilteredListData] = useState(null)
    const [activeForm, setActiveForm] = useState([])
    const [count, setCount] = useState(null);
    const [openMoreMenuId, setOpenMoreMenuId] = useState(null);
    const [passwordModalOpen, setPasswordModalOpen] = useState(false);
    const [formId, setFormId] = useState(null);
    const [statusForm , setStatusForm] = useState(null)

    const dropdownRef = useRef(null);
    const toggleDrawer = () => {
        setIsOpen((prevState) => !prevState)
    }

    const transitions = useTransition(active, {
        from: { opacity: 0, transform: 'translateY(-20px)' },
        enter: { opacity: 1, transform: 'translateY(0)' },
        leave: { opacity: 0, transform: 'translateY(-20px)' },
    });

    const moreMenuTransitions = useTransition(openMoreMenuId, {
        from: { opacity: 0, transform: 'translateY(-10px)' },
        enter: { opacity: 1, transform: 'translateY(0)' },
        leave: { opacity: 0, transform: 'translateY(-10px)' },
    });

    const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
    const token = localStorage.getItem('authToken');


    const getCurrentListSetter = () => {
        return setList;
    };


    const getCurrentList = () => {
        return list;
    };


    const handleFilterForm = (heading, status, id) => {
        setHeading(heading)
        saveStatusForm(status)
        setActiveFilter(id)
        localStorage.setItem('activeFilter', id)
    }


    const handleChangeCheckBox = (id) => (event) => {

        const targetList = getCurrentList();
        const setTargetList = getCurrentListSetter();

        const updatedList = targetList.map(item =>
            item.id === id ? { ...item, checked: event.target.checked } : item
        );

        const activeFormIds = updatedList
            .filter(item => item.checked) // Only keep checked items
            .map(item => item.id);       // Extract their IDs

        setActiveForm(activeFormIds);
        setTargetList(updatedList);
    };

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };


    const isAnyItemChecked = getCurrentList()?.some(item => item.checked);


    const initializeListData = (data) => {
        return data?.map(item => ({
            ...item,
            checked: item.checked || false // Default to false if `checked` doesn't exist
        }));
    };


    const handleChangeStarCheckBoxWrapper = (id) => (event) => {
        handleChangeStarCheckBox({ id, token, setLoading, handleGetListForm });
    };

    const handleGetFormDetailsWrapper = (id, status ,  password = null) => {
        setStatusForm(status)
        handleGetFormDetails({ id, status, token, setLoading, setError, setFormFullDetails, setDrawerData, setTitle, setEditMode, navigate, setPasswordModalOpen, setFormId , password });
    };

    const handleGetListResponseFormWrapper = (id) => {
        handleGetListResponseForm({ id, setLoading, setError, setListResponse, navigate });
    };

    const copyFormLinkWrapper = (id) => {
        copyFormLink(id);
    };


    const handleGetListForm = () => {
        handleGetListForms({
            sectionUrls,
            token,
            setLoading,
            setList,
            setCount,
            setError
        });
    };



    useEffect(() => {
        const initializedData = initializeListData(list);
        let filter = initializedData?.filter(item =>
            item.title?.toLowerCase().includes(searchTerm.toLowerCase())
        );

        setFilteredListData(filter)
    }, [list, searchTerm]);



    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setActive(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    useEffect(() => {
        setFavoriteItems(favoriteItems);
    }, [favoriteItems, setFavoriteItems]);


    useEffect(() => {
        setSwitchSection(sectionUrls[selectDrawerItem] || '');
    }, [selectDrawerItem]);


    useEffect(() => {

        handleGetListForm()

    }, [switchSection, statusForms, pageCount]);



    useEffect(() => {
        setPageCount(1)
    }, [])


    useEffect(() => {
        function handleClickOutside(event) {
            if (
                moreMenuRef.current &&
                !moreMenuRef.current.contains(event.target)
            ) {
                setOpenMoreMenuId(null);
            }
        }

        if (openMoreMenuId !== null) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        // Cleanup
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openMoreMenuId]);


    useEffect(() => {
        return () => {
            const newLimitSetting = {
                maxUses: null,
                startDate: null,
                endDate: null,
                password: null
            };
            setPasswordProtectionForm(null)
            handleChangeLimitSetting(newLimitSetting)
        };
    }, []);


    return (
        <Grid width={{ xs: '100%' }} display={'block'}>
            <Loading />
            <Grid width={{ xs: '100%' }} p={{ xs: '14px 10px', md: '9px 13px' }} display={'flex'} alignItems={'center'} justifyContent={{ xs: 'space-between', md: 'flex-end' }} bgcolor={'white'}>
                <Box display={{ xs: 'block', md: 'none' }}>
                    <Grid onClick={toggleDrawer} display={'flex'} alignItems={'center'} p={'0px 10px'} border={'1px solid rgba(200,206,237,1)'} width={'40px'} height={'40px'} borderRadius={'4px'}>
                        <img src='/assets/images/threeDots.svg' alt='' style={{ width: '100%', height: '100%' }} />
                    </Grid>
                </Box>
                <MobileMainDrawer isOpen={isOpen} toggleDrawer={toggleDrawer} />
                {
                    isAnyItemChecked ?
                        (
                            <MainNavbarButtonAction selectDrawerItem={selectDrawerItem} listId={activeForm} />
                        )
                        :
                        (

                            <Box display={'flex'} alignItems={'center'} gap={'8px'}>
                                <Grid sx={{ position: 'relative' }}>
                                    <input
                                        style={{
                                            height: '40px',
                                            borderRadius: '4px',
                                            color: 'rgba(10,21,81,1)',
                                            border: '1px solid rgba(200,206,237,1)',
                                            backgroundColor: 'rgba(255,255,255,1)',
                                            outline: 'rgba(0,0,0,1)',
                                            padding: '0px 32px'
                                        }}
                                        placeholder='جستجو'
                                        value={searchTerm}
                                        onChange={handleSearch}
                                    />
                                    <Grid width={'20px'} height={'20px'} sx={{ position: 'absolute', top: '10px', right: '10px' }}>
                                        <img src='/assets/images/magnifyingGlass.svg' alt='' style={{ width: '100%', height: '100%' }} />
                                    </Grid>
                                </Grid>
                                <Grid style={{ position: 'relative', cursor: 'pointer' }} ref={dropdownRef}>
                                    <Grid p={'0px 10px'} border={active ? '1px solid rgb(44, 51, 69)' : '1px solid rgba(200,206,237,1)'} width={'40px'} height={'40px'} borderRadius={'4px 4px 4px 0px'} onClick={() => { setActive(!active) }} bgcolor={active ? 'rgb(44, 51, 69)' : 'white'}>
                                        <img src='/assets/images/sort.svg' alt='' style={{ width: '100%', height: '100%' }} />
                                    </Grid>
                                    {transitions(
                                        (styles, item) =>
                                            item && (
                                                <animated.div
                                                    style={{
                                                        ...styles,
                                                        position: 'absolute',
                                                        top: '38px',
                                                        left: '0px',
                                                        zIndex: 100,
                                                        backgroundColor: 'rgb(44, 51, 69)',
                                                        borderRadius: '0px 4px 4px 4px',
                                                        padding: '8px',
                                                        width: '244px',
                                                    }}
                                                >
                                                    {sortItems.map((item) => (
                                                        <Button
                                                            onClick={() => handleFilterForm(item.title, item.status, item.id)}
                                                            key={item.id}
                                                            sx={{
                                                                backgroundColor: item.id === activeFilter ? 'white' : 'transparent',
                                                                fontSize: '14px',
                                                                fontWeight: 500,
                                                                color: item.id === activeFilter ? 'rgb(44, 51, 69)' : 'white',
                                                                width: '100%',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'flex-start',
                                                                '&:hover': { backgroundColor: 'white', color: 'rgb(44, 51, 69)' },
                                                            }}
                                                        >
                                                            {item.title}
                                                        </Button>
                                                    ))}
                                                </animated.div>
                                            )
                                    )}
                                </Grid>
                            </Box>
                        )
                }

            </Grid>
            <Grid style={{ height: '600px', maxHeight: '600px', overflowY: 'auto' }} mt={'16px'}>
                {
                    filteredListData?.length > 0
                        ?
                        <>
                            {
                                filteredListData.map(
                                    (item, index) =>
                                        <FormItemRow
                                            key={index}
                                            item={item}
                                            index={index}
                                            filteredListData={filteredListData}
                                            selectDrawerItem={selectDrawerItem}
                                            checked={checked}
                                            label={label}
                                            handleChangeCheckBox={handleChangeCheckBox}
                                            handleChangeStarCheckBoxWrapper={handleChangeStarCheckBoxWrapper}
                                            copyFormLinkWrapper={copyFormLinkWrapper}
                                            handleGetFormDetailsWrapper={handleGetFormDetailsWrapper}
                                            handleGetListResponseFormWrapper={handleGetListResponseFormWrapper}
                                            moreMenuRef={moreMenuRef}
                                            moreMenuTransitions={moreMenuTransitions}
                                            openMoreMenuId={openMoreMenuId}
                                            setOpenMoreMenuId={setOpenMoreMenuId}
                                            setLoading={setLoading}
                                            handleGetListForm={handleGetListForm}
                                            token={token}
                                        />
                                )
                            }
                            <Grid mt={'10%'} display={'flex'} justifyContent={'center'} alignItems={'center'} dir={'rtl'}>
                                <PaginationForms count={count} />
                            </Grid>
                        </>
                        :
                        <Grid width={'300px'} display={'flex'} alignItems={'center'} justifyContent={'center'} mx={'auto'}>
                            <MainMessage search={searchTerm} />
                        </Grid>
                }
            </Grid>
            <PasswordModal
                open={passwordModalOpen}
                onClose={() => setPasswordModalOpen(false)}
                onSubmit={(password) => {
                    setPasswordModalOpen(false);
                    handleGetFormDetails({
                        id: formId,
                        status: statusForm,
                        token,
                        setLoading,
                        setError,
                        setFormFullDetails,
                        setDrawerData,
                        setTitle,
                        setEditMode,
                        navigate,
                        password,
                    });
                }}
            />

        </Grid>
    )
}

export default MainNavbar